/**
 * /v/$proposalId — Suggestion page.
 *
 * Two views, switchable from the top bar:
 *   - `view=changes` (default): highlight what this update changes, with
 *     the change rail anchored to each affected block.
 *   - `view=canvas`: render the canvas as it would look with this update
 *     applied (or as it looked at this past version), with no markers and
 *     no rail.
 *
 * Implementation lives in `components/suggestion/SuggestionPreview` so it
 * can also be embedded inline (e.g. inside a sheet on smaller screens).
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { SuggestionPreview } from "../../components/suggestion/SuggestionPreview";

const searchSchema = z.object({
  canvasId: z.string().optional(),
  view: z.enum(["changes", "canvas"]).optional(),
});

export const Route = createFileRoute("/_app/v/$proposalId")({
  validateSearch: searchSchema,
  component: VersionPage,
});

function VersionPage() {
  const { proposalId } = Route.useParams();
  const { canvasId, view } = Route.useSearch();
  return (
    <SuggestionPreview
      proposalId={proposalId}
      canvasIdHint={canvasId}
      view={view ?? "changes"}
    />
  );
}
